import { IMuWidget } from "./IMuWidget";
import {MuWidget} from "mu-widget/lib/MuWidget";

export class UiFlashMessage extends MuWidget
{
	public static instance: UiFlashMessage;

	public afterIndex()
	{
		this.updateVisibility();
		UiFlashMessage.instance = this;
	}

	public updateVisibility() 
	{
		// @ts-ignore
		this.container.style.display = this.ui.items.firstElementChild
			? null
			: "none";
	}

	public add(text : string, template : string = 'item') : UiLoaderItem
	{
		// @ts-ignore
		var item = this.muWidgetFromTemplate(template, "items", {
			text: text,
			showDuration: template === 'loader' ? null : 7000,
		}) as UiLoaderItem;
		this.updateVisibility();
		return item;
	}
}

export class UiLoaderItem extends IMuWidget
{
	public text : string = "";

	public showDuration: number|null = 7000;

	public afterIndex()
	{
		this.ui.text.innerText = this.text;
		if (this.showDuration) {
			setTimeout(() => this.container.toggleAttribute('loader-item__removing'), this.showDuration);
			setTimeout(() => this.muRemoveSelf(), this.showDuration + 3000);
		}
	}

	public remove() : void
	{
		this.muRemoveSelf();
		(this.muParent as unknown as UiFlashMessage).updateVisibility();
	}

	public bClose_click() : void
	{
		this.remove();
	}
}
